<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'LICENSE_CATEGORIES' }
  ]"
></breadcrumbs>

<page-header title="LICENSE_CATEGORIES"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('results')"
  [itemsPerPage]="getQueryParam('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getQueryParam('page')"
  (onPageChange)="handlePageChange($event)"
  (onPageSizeChange)="handlePageSizeChange($event)"
  (onSort)="handleSort($event)"
  [sort]="getQueryParam('sort')"
  [orderBy]="getQueryParam('order_by')"
  [columns]="columns"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <a
        [routerLink]="['create']"
        class="button is-small is-info"
        translationEditableDirective="CREATE_LICENSE_CATEGORY"
        >{{ 'CREATE_LICENSE_CATEGORY' | translate }}</a
      >
    </div>
    <form>
      <input
        class="input is-small"
        type="text"
        (input)="handleFilterChange($event)"
        [value]="getQueryParam('keyword')"
        name="keyword"
        [translationEditableModalDirective]="['SEARCH']"
        [placeholder]="'SEARCH' | translate"
      />
    </form>
  </ng-template>

  <ng-template let-row="row" #actionsColumn>
    <div class="buttons m-0">
      <a
        [routerLink]="[row.get('id'), 'update']"
        class="button is-small"
        translationEditableDirective="UPDATE"
        >{{ 'UPDATE' | translate }}</a
      >
      <alert
        #deleteAlert
        (confirm)="deleteBusinessCategory(row.get('id'))"
        titleTrnKey="ARE_YOU_SURE"
        textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
      />
      <button
        class="button is-danger is-small"
        (click)="deleteAlert.fire()"
        translationEditableDirective="DELETE"
      >
        {{ 'DELETE' | translate }}
      </button>
    </div>
  </ng-template>
</app-table>
